import React from "react";
import IserbaAvatarStep from "components/onboarding/iserba/IserbaAvatarStep";
import OrtivisAvatarStep from "components/onboarding/ortivis/OrtivisAvatarStep";

const AvatarStep = ({ quizOrganizationId, player, onAvatarChosen }) => {
	if (quizOrganizationId === "1af3a66b-316d-4be0-8332-eb7bc15f4e27") {
		return <IserbaAvatarStep player={player} onAvatarChosen={onAvatarChosen} />;
	} else if (quizOrganizationId === "2f116da7-d51e-459d-8e05-2b2bcc8d0723") {
		return (
			<OrtivisAvatarStep player={player} onAvatarChosen={onAvatarChosen} />
		);
	}

	// Show default avatar picker when no specific quizWrapper is provided
	return <OrtivisAvatarStep player={player} onAvatarChosen={onAvatarChosen} />;
};

export default AvatarStep;
